var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72096 11.4419C2.56745 11.4419 0 8.87446 0 5.72096C0 2.56745 2.56745 0 5.72096 0C8.87446 0 11.4419 2.56745 11.4419 5.72096C11.4419 8.87446 8.87446 11.4419 5.72096 11.4419ZM5.72096 0.837213C3.02513 0.837213 0.837213 3.03071 0.837213 5.72096C0.837213 8.4112 3.02513 10.6047 5.72096 10.6047C8.41678 10.6047 10.6047 8.4112 10.6047 5.72096C10.6047 3.03071 8.41678 0.837213 5.72096 0.837213Z",
    fill: "#B5B5B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5816 12C11.4755 12 11.3695 11.9609 11.2858 11.8772L10.1695 10.7609C10.0076 10.5991 10.0076 10.3312 10.1695 10.1693C10.3314 10.0074 10.5993 10.0074 10.7611 10.1693L11.8774 11.2856C12.0393 11.4475 12.0393 11.7154 11.8774 11.8772C11.7937 11.9609 11.6876 12 11.5816 12Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.6d47426094344e1832e414b376231346.svg";
export { ForwardRef as ReactComponent };